<template>
  <v-card
    elevation="0"
    style="width: 840px; margin-right: 140px"
  >
    <v-card-title
      class="pt-0"
      style="height: 52px;"
    >
      {{ $t('billing.billing') }}
    </v-card-title>
    <v-card-text>
      <v-col cols="16">
        <div
          style="font-size: 18px; font-weight: bold;"
          class="mt-3"
        >
          {{ $t('billing.invoices') }}
        </div>

        <main-table />
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import MainTable from '@/components/billing/BillingMainTable.vue'

export default {
  name: 'Billing',

  components: {
    MainTable
  },

  computed: {
    ...mapGetters({
      profile: 'main/profile'
    })
  },
}
</script>
